import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { adresPro2, findMieszkanieId, sortujLokale } from "../../../functions/ulice";
import { zl, isNumber } from "../../../functions/utilities";
import { mm_rrrr_to_date } from "../../../functions/dataFormat";
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const WspolnotaRaportZbiorowyTBody = ( props ) => {

    const { mieszkancy, listaMsc, idw_temp, czynszeWspolnota, przelewyWspolnota, visible, czyRok, przelewyRok, czynszeRok, rozliczenieWody,
        przelewyWidoczne, czynszeWidoczne, handleShowKomornik } = props;

    const lokale = useSelector( state => state?.lokale?.data);
    const ulice = useSelector( state => state?.ulice?.data);
    const grupy = useSelector( state => state?.grupy?.data);
    const udzialyKontaAkt = useSelector( state => state?.udzialyKontaAkt?.data);

    const [zestaw, setZestaw] = useState([]);

    useEffect( () => {
        const temp = udzialyKontaAkt?.map( ( udzial, i) => {

            const mieszkaniec = mieszkancy.find( mieszkaniec => mieszkaniec.id_user == udzial.id_user);

            const grupy_u = grupy?.filter( g => g?.id_user == udzial?.id_user && g?.grupa_numer == udzial?.grupa_numer);
            const adres = adresPro2(udzial, lokale, ulice, grupy_u);
            const lokalId = findMieszkanieId(udzial, grupy_u, lokale);
            const lokal = lokale?.find( u => u?.id == lokalId);
            
            return ({
                ...udzial,
                mieszkaniec,
                adres,
                ulicaId: lokal?.ulica,
                lokalNr: lokal?.numer,
                lokalId: lokal?.id,
                lokalRodzaj: lokal?.rodzaj
            })
        })

        setZestaw(sortujLokale(temp));
    },[udzialyKontaAkt, mieszkancy, grupy, lokale, ulice]);
    
    const tab = zestaw?.map( (udzial, i) => {

        const { mieszkaniec, adres } = udzial;

        const grupyMsc = czynszeWspolnota?.find( czynsz => czynsz?.id_user == udzial?.id_user)?.grupy_udzial_msc?.find( c => c?.grupa_numer == udzial.grupa_numer);

        const przelewyRokUdzial = czyRok && przelewyRok?.length > 0 ? przelewyRok?.find( p => p?.id_user == udzial?.id_user && p?.grupa_numer == udzial?.grupa_numer)?.kwota : 0;
        const czynszeRokUdzial = czyRok && czynszeRok?.length > 0 ? czynszeRok?.find( c => c?.id_user == udzial?.id_user && c?.grupa_numer == udzial?.grupa_numer)?.kwota : 0;

        const rok = czyRok && (
            <td style={{fontWeight: "600", whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                { zl( przelewyRokUdzial - czynszeRokUdzial )}
            </td>
        );

        const sumaNaleznosciWidoczne = czynszeWidoczne?.find( c => c?.id_user == udzial?.id_user && c?.grupa_numer == udzial?.grupa_numer )?.kwota;
        const sumaPrzelewyWidoczne = przelewyWidoczne?.find( c => c?.id_user == udzial?.id_user && c?.grupa_numer == udzial?.grupa_numer )?.kwota;
        
        const miesiace = grupyMsc && listaMsc?.map( (msc, i) => {

            const czynszTemp = grupyMsc?.temp_msc?.find( g => g?.msc == msc)?.czynsz_na_msc;
            const czynszLast = grupyMsc?.temp_msc[grupyMsc?.temp_msc?.length -1]?.czynsz_na_msc;

            const czynsz_na_msc = czynszTemp === undefined && mm_rrrr_to_date(msc) >= mm_rrrr_to_date(grupyMsc?.temp_msc[grupyMsc?.temp_msc?.length -1].msc) ? czynszLast : czynszTemp;

            
            const woda_msc = rozliczenieWody?.find( r => r.miesiac ==  msc)?.procenty?.find( p => p?.id_user == udzial?.id_user && p?.grupa_numer == udzial?.grupa_numer )?.saldo || 0;

            
            const suma_czynsze_msc = (czynsz_na_msc || 0) + woda_msc;

            const przelewy = przelewyWspolnota?.find( p => p?.id_user == udzial?.id_user && p?.nr_grupyUdzial == udzial?.grupa_numer)?.przelewy;

            let sumaPrzelewy = 0;

            const przelewyMsc = przelewy?.filter( p => p?.msc == msc)
            
            sumaPrzelewy += przelewyMsc?.reduce((acc, obj) => {
                return acc + ( isNumber(obj.kwota) ? obj.kwota : 0 );
            },0);
            
            if (!visible) {
                return (
                    <Fragment key={i}></Fragment>
                )
            } else {
                return (
                    <Fragment key={i}>
                        <td style={{whiteSpace: "nowrap", textAlign: "right" }}>{`${zl(suma_czynsze_msc)}`}</td>
                        <td style={{whiteSpace: "nowrap", textAlign: "right" }}>{zl(sumaPrzelewy)}</td>
                        <td style={{fontWeight: "600", whiteSpace: "nowrap", textAlign: "right" }}>
                            { zl((sumaPrzelewy - suma_czynsze_msc) )}
                        </td>
                    </Fragment>
                )
            }
        })

        const podsumowanie = (
            <Fragment>
                <td style={{whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                    {zl(sumaNaleznosciWidoczne)}
                </td>
                <td style={{whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                    {zl(sumaPrzelewyWidoczne)}
                </td>
                <td style={{fontWeight: "600", whiteSpace: "nowrap", backgroundColor: "var(--podswietlenie)", textAlign: "right" }}>
                    { zl((sumaPrzelewyWidoczne - sumaNaleznosciWidoczne) + (przelewyRokUdzial - czynszeRokUdzial))}
                </td>
            </Fragment>
        )

        const nrGrupyTxt = idw_temp !== null ? `, (nr gr.: ${udzial?.grupa_numer})` : '';
        const idUserTxt = idw_temp !== null ? ` (id ${mieszkaniec?.id_user})` : '';

        return (   
            <tr key={i}>
                <td style={{whiteSpace: "nowrap", textAlign: "left" }}>
                    {`${mieszkaniec?.imie_nazwisko}${idUserTxt}${nrGrupyTxt}`}
                </td>
                <td style={{whiteSpace: "nowrap", textAlign: "left" }}>
                    {`${ adres?.length > 0 ? adres : "brak mieszkania" }`}
                </td>
                <td>
                    <FontAwesomeIcon 
                        icon={faPrint} 
                        className='pointer'
                        onClick={()=>{handleShowKomornik(mieszkaniec?.id_user, udzial?.grupa_numer)}}
                    />
                </td>
                <Fragment>
                    {rok}
                    {miesiace}
                    {podsumowanie}
                </Fragment>
            </tr>
        )
    }) 

    return (
        <tbody>
            {tab}
        </tbody>
    ) 
}

export default WspolnotaRaportZbiorowyTBody;